export default {
  carPrice: 'هزینه خودرو',
  carCommission: 'کمیسیون خودرو',
  carCompanyDiscount: 'تخفیف باربری (خودرو)',
  carMarketplaceDiscount: 'تخفیف باربانت (خودرو)',
  carExtraHourPrice: 'هزینه ساعت اضافه (خودرو)',
  carExtraKilometerPrice: 'هزینه کیلومتر اضافه (خودرو)',
  carExtraHourCommission: 'کمیسیون ساعت اضافه (خودرو)',
  carExtraKilometerCommission: 'کمیسیون کیلومتر اضافه (خودرو)',
  carExcessCommission: 'کمیسیون هزینه مازاد (خودرو)',
  laborerPrice: 'هزینه کارگر',
  laborerCommission: 'کمیسیون کارگر',
  laborerCompanyDiscount: 'تخفیف باربری (کارگر)',
  laborerMarketplaceDiscount: 'تخفیف باربانت (کارگر)',
  laborerExtraHourPrice: 'هزینه ساعت اضافه (کارگر)',
  laborerExtraHourCommission: 'کمیسیون ساعت اضافه (کارگر)',
  price: 'هزینه',
  commission: 'کمیسیون',
  companyDiscount: 'تخفیف باربری',
  marketplaceDiscount: 'تخفیف باربانت',
  extraHourPrice: 'هزینه ساعت اضافه',
  extraHourCommission: 'کمیسیون ساعت اضافه',
  editor: 'ویراستار',
  create: 'درج',
  update: 'ویرایش',
  delete: 'حذف',
  generate: 'تولید',
  import: 'درج انبوه',
  upsert: 'درج-ویرایش',
  logicalDelete: 'حذف منطقی',
  enable: 'فعال‌سازی',
  disable: 'غیر فعال‌سازی',
  patch: 'ویرایش اندک',
  flag: 'ویرایش فیلد',
  revert: 'ابطال',
  complex: 'پیچیده',
  vehicleId: 'شناسه خودرو',
  tariffId: 'شناسه تعرفه',

  // translate log user
  latitude: 'عرض جغرافیایی',
  longitude: 'طول جغرافیایی',
  address: 'آدرس',
  id: 'شناسه',
  creationTime: 'تاریخ ایجاد',
  title: 'عنوان',
  slug: 'slug',
  sortOrder: 'ترتیب',
  userId: 'شناسه کاربر',
  countryId: 'شناسه کشور',
  provinceId: 'شناسه استان',
  countyId: 'شناسه شهرستان',
  cityId: 'شناسه شهر',
  zipCode: 'کد پستی',
  plate: 'پلاک',
  floor: 'طبقه',
  unit: 'واحد',
  phone: 'تلفن',
  mobile: 'موبایل',
  primary: 'آدرس اصلی',
  hashedPassword: 'پسورد هش شده',
  firstName: 'نام کوچک',
  lastName: 'نام خانوادگی',
  mobileConfirmTime: 'زمان تائید موبایل',
  fullName: 'نام کامل',
  name: 'نام',
  twoFactorEnabled: 'تایید دو مرحله ای',
  email: 'ایمیل',
  gender: 'جنسیت',
  father: 'نام پدر',
  birthYear: 'سال تولد',
  bankCard: 'شماره کارت بانکی',
  realmRoles: 'حوزه دسترسی',

  // vehicle
  modelFeatureId: 'شناسه نوع خودرو',
  brandId: 'شناسه برند',
  companyId: 'شناسه باربری',
  color: 'رنگ',
  code: 'کد',
  year: 'سال',
  plateIranNumber: 'شماره پلاک ایران',
  plateLeftNumber: 'شماره سمت چپ پلاک',
  plateCharacter: 'حرف پلاک',
  plateRightNumber: 'شماره سمت راست پلاک',
  platePlaceOfIssue: 'محل صدور پلاک',
  plateOwnerId: 'شماره هویتی مالک',

  //driver
  driverId: 'شناسه راننده',

  // security
  permissions: 'سطوح دسترسی',
  cascade: 'ارث بری خودکار',

  //shipment
  clientType: 'نوع مشتری',
  range: 'محدوده',
  type: 'نوع',
  state: 'وضعیت',
  totalAmount: 'مبلغ کل',
  payableAmount: 'مبلغ قابل پرداخت',
  details: 'جزئیات',
  estimatedDistance: 'فاصله تخمینی',
  estimatedDuration: 'مدت زمان تخمینی',
  taxAmount: 'مقدار مالیات',
  tollAmount: 'مقدار عوارض',
  commissionAmount: 'مقدار کمیسیون',
  companyFeeAmount: 'مبلغ کارمزد باربری',
  marketplaceDiscountAmount: 'مقدار تخفیف بازار',
  companyDiscountAmount: 'مقدار تخفیف باربری',
  estimatedPolyLine: 'PolyLine تخمین زده شده',
  acceptTime: 'زمان پذیرش',
  excessAmount: 'مقدار اضافی',
  tariffBased: 'براساس تعرفه',
  orderTime: 'زمان سفارش',
  roundTrip: 'بازگشت به مبدا',
  waitMinute: 'زمان توقف',
  timeSheetTemplateId: 'شناسه الگوی زمانی',
  timeSheetDate: 'زمان برگه',
  cancelTime: 'زمان انصراف',
  dischargeTime: 'تاریخ تخلیه',
  dischargeDayPart: 'زمان تخلیه',
  loadId: 'شناسه نوع بار',
  packageId: 'شناسه نوع بسته بندی',
  document: 'نوع سند',
  weightTon: 'وزن',
  monetaryValue: 'ارزش بار',
  cancelable: 'قابل کنسل شدن',
  pricingType: 'نحوه قیمت دهی',
  attachments: 'پیوست ها',
  tester: 'کاربر تستی',

  // courier
  roles: 'نقش ها',
  provinces: 'استان ها',
  addressCountryId: 'شناشه کشور آدرس',
  addressProvinceId: 'شناشه کشور آدرس',
  addressCountyId: 'شناشه شهرستان آدرس',
  addressCityId: 'شناشه شهر آدرس',
  addressLatitude: 'عرض جغرافیایی',
  addressLongitude: 'طول جغرافیایی',
  addressAddress: 'آدرس',
  addressZipCode: 'کد پستی آدرس',
  nationalId: 'شناسه ملی',
  economicCode: 'شناسه اقتصادی',
  negotiatorName: 'نام رابط',
  negotiatorMobile: 'موبایل رابط',
  brand: 'برند',
  image: 'تصویر',
  description: 'توضیحات',
  holdingId: 'شناسه هلدینگ',
  ownerId: 'شناسه مالک',
  approved: 'تائید شده',
  registrationNumber: 'شماره ثبت',
  cities: 'شهرها',

  // time-sheet
  trafficPlanId: 'شناسه طرح ترافیک',
  weekDay: 'روز هفته',
  startTime: 'ساعت شروع',
  endTime: 'ساعت پایان',
  courierId: 'شناسه باربری',

  //geo
  autoExpand: 'گسترش سیستمی',
  expandedMeter: 'شعاع گسترش',
  priority: 'اولویت',

  // gateway
  provider: 'ارائه دهنده سرویس',
  username: 'نام کاربری',
  password: 'کلمه عبور',
  sendNumber: 'شماره ارسال کننده',
  terminalId: 'شناسه ترمینال',

  cause: 'علت',
  stackTrace: 'ردیابی پشته',
  methodName: 'نام متد',
  className: 'نام کلاس',
  method: 'متد',
  unHandled: 'کنترل نشده',

  //web-service
  service: 'سرویس',

  report: 'گزارش',
  detail: 'جزئیات',
  index: 'شاخص گذاری',
  export: 'خروجی اکسل',
  instantiate: 'ساختن از روی الگو/نمونه',
  editImage: 'ویرایش تصویر',
  soilId: 'شناسه نوع خاک',
  suspendId: 'شناسه تعلیق',
  poiId: 'شناسه آدرس سراسری',
  poiCategoryId: 'شناسه دسته آدرس سراسری',

  // general
  requestParameters: 'پارامتر های ارسالی',
  requestHeaders: 'هدر های ارسالی'
}
